/** Row shape from GET `/inventory/objects/:id/object-types/full` (after axios unwrap). */
export type InventMapObjectTypeRow = {
  id: number
  object_name: string
  icon: string
  sub_types?: InventMapSubtypeRow[]
}

export type InventMapSubtypeRow = {
  id: number
  name: string
  figure?: { geom_type?: string }
  functional_type?: string
  dependencies_list?: number[]
  [key: string]: unknown
}

/**
 * Axios interceptor unwraps `{ data: T }` onto `response.data`.
 * TanStack Query may store either the full response or `response.data` depending on queryFn.
 */
export function unwrapFullTypesList(responseData: unknown): InventMapObjectTypeRow[] {
  if (Array.isArray(responseData)) {
    return responseData as InventMapObjectTypeRow[]
  }
  if (
    responseData &&
    typeof responseData === 'object' &&
    'data' in responseData &&
    Array.isArray((responseData as { data: unknown }).data)
  ) {
    return (responseData as { data: InventMapObjectTypeRow[] }).data
  }
  return []
}
